import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SoftButton from "../../components/SoftButton";
import {useLocation, useNavigate} from "react-router-dom";
import {useRecoilState, useRecoilValue, useResetRecoilState} from "recoil";
import {vacationInsertAtom} from "../../atom/vacation/vacationInsertAtom";
import {approverInsertAtomFamily} from "../../atom/approval/approver_referrer/approverInsertAtomFamily";
import {referrerInsertAtomFamily} from "../../atom/approval/approver_referrer/referrerInsertAtomFamily";
import {useEffect} from "react";
import {toMap} from "../../utils/ToMap";
import cloneDeep from "lodash.clonedeep";
import VacationInputArea from "./components/VacationInputArea";
import {loginUser} from "../../atom/member/loginUser";
import ApproverReferrer from "./components/ApproverReferrer";
import {approverCountAtomFamily} from "../../atom/approval/approver_referrer/approverCountAtomFamily";
import {referrerCountAtomFamily} from "../../atom/approval/approver_referrer/referrerCountAtomFamily";
import Swal from "sweetalert2";
import {useMutation} from "react-query";
import InsertVacation from "../../api/vacation/insertVacation";
import Loading from "../../components/loading/Loading";
import {vacationPhoneValueAtom} from "../../atom/vacation/vacationPhoneValueAtom";
import {PhoneNumCheck} from "../../utils/PhoneNumCheck";
import {vacationReasonValueAtom} from "../../atom/vacation/vacationReasonValueAtom";
import {selectDaysAtomFamily} from "../../atom/calendar/selectDaysAtomFamily";
import {radioValueAtomFamily} from "../../atom/radioCheckBox/radioCheckBox";
import {vacationDayStateAtom} from "../../atom/vacation/vacationDayStateAtom";
import {vacationUseDayValueAtom} from "../../atom/vacation/vacationUseDayValueAtom";

/**
 * vacation Insert
 * @returns {JSX.Element}
 * @constructor
 */
function VacationInsert() {

    // navigate
    const navigate = useNavigate();
    const location = useLocation();

    // 하위 컴포넌트에서 아톰패밀리 접근 키값
    const approverKey = location.state.approverKey;
    const referrerKey = location.state.referrerKey;
    const insertKey = location.state.insertKey;

    // 첫 마운트 시 이전에 있던 값들 리셋
    const vacationInfoReset = useResetRecoilState(vacationInsertAtom); // 휴가 정보
    const approverListReset = useResetRecoilState(approverInsertAtomFamily(approverKey)); // 결재자 리스트
    const referrerListReset = useResetRecoilState(referrerInsertAtomFamily(referrerKey)); // 참조자 리스트
    const approverCountReset = useResetRecoilState(approverCountAtomFamily(approverKey)); // 결재자 수
    const referrerCountReset = useResetRecoilState(referrerCountAtomFamily(referrerKey)); // 참조자 수
    const telReset = useResetRecoilState(vacationPhoneValueAtom); // 연락처
    const reasonReset = useResetRecoilState(vacationReasonValueAtom); // 휴가 사유
    const dateReset = useResetRecoilState(selectDaysAtomFamily(insertKey+"_day")); // 휴가 일정
    const categoryReset = useResetRecoilState(radioValueAtomFamily(insertKey+"_category")); // 카테고리
    const vacationDayErrorReset = useResetRecoilState(vacationDayStateAtom); // 휴가 사용일 에러
    const vacationUseDayReset = useResetRecoilState(vacationUseDayValueAtom); // 휴가 사용일


    // 리셋 함수
    const atomReset = () => {
        vacationInfoReset();
        approverListReset();
        referrerListReset();
        approverCountReset();
        referrerCountReset();
        telReset();
        reasonReset();
        dateReset();
        categoryReset();
        vacationDayErrorReset();
        vacationUseDayReset();
    }

    // 리셋 실행
    useEffect(()=>{
        atomReset();
    },[])

    // 휴가 입력 값
    const [vacationInfo, setVacationInfo] = useRecoilState(vacationInsertAtom);
    // 결재자 정보
    const approverInfo = useRecoilValue(approverInsertAtomFamily(approverKey));
    // 참조자 정보
    const referrerInfo = useRecoilValue(referrerInsertAtomFamily(referrerKey));
    // 로그인정보
    const user = useRecoilValue(loginUser);
    // 전화번호
    const vacationTelInfo = useRecoilValue(vacationPhoneValueAtom);
    // 휴가사유
    const vacReason = useRecoilValue(vacationReasonValueAtom);
    // 휴가 시작일 : start, 종료일 : end, 휴가일수 : day
    const vacationDateInfo = useRecoilValue(selectDaysAtomFamily(insertKey+"_day"));
    // 휴가 구분 : value
    const vacationCategory = useRecoilValue(radioValueAtomFamily(insertKey+"_category"));
    // 휴가 사용일 스테이트 : boolean
    const vacationDayError = useRecoilValue(vacationDayStateAtom);
    // 휴가 사용예정일
    const vacUseDay = useRecoilValue(vacationUseDayValueAtom);

    // 임시보관
    function temporary() {
        let flag = true;
        const insert = toMap(vacationInfo);
        insert.set("auth_no", user?.role);
        insert.set("mem_no", user?.id);
        insert.set("mem_name", user?.name);
        insert.set("vac_team", user?.team);
        insert.set("vac_rank", user?.rank);
        const approverList = cloneDeep(approverInfo).approverList;
        insert.set("approverList", approverList);
        insert.set("referrerList", cloneDeep(referrerInfo).referrerList);

        if(vacationDateInfo.start === "" || vacationDateInfo.end === ""){
            flag=false;
            vacationErrorHandle("휴가 일정을 올바르게 선택하여 주십시오.");
        } else if(vacationDayError !== true){
            flag=false;
            vacationErrorHandle("사용예정 일수와 잔여 연차가 맞지 않습니다. 확인하여 주십시오.");
        } else if (vacationCategory.value === "" || vacationCategory.value === undefined) {
            flag=false;
            vacationErrorHandle("휴가 구분을 올바르게 선택하여 주십시오.");
        } else if (PhoneNumCheck(vacationTelInfo) === false) {
            flag=false;
            vacationErrorHandle("연락처를 올바르게 입력하여 주십시오.");
        } else if(vacUseDay === "" || vacUseDay === "0"){
            flag=false;
            vacationErrorHandle("사용예정 휴가일을 확인해주세요.");
        } else if (vacReason === "") {
            flag=false;
            vacationErrorHandle("휴가 사유를 입력하여 주십시오.");
        } else if (approverList !== null){
            if (approverList.length > 0 ) {
                insert.set("vac_approved", "AP005");
            } else {
                flag=false;
                vacationErrorHandle("결재자를 선택하여 주십시오.");
            }
        } else if(vacUseDay === null || vacUseDay === undefined || vacUseDay === 0 || vacUseDay === '' || vacUseDay === ' '){
            flag=false;
            vacationErrorHandle("사용예정 휴가일을 확인해주세요.");
        } else {
            flag=false;
            vacationErrorHandle("결재자를 선택하여 주십시오.");
        }

        if(flag) {
            if(vacationCategory.value === "VT003") {
                Swal.fire({
                    title: "1. 예비군 교육훈련 필증, 민방위 훈련 참가 필증을 경영지원부에 꼭 제출해주세요.\n2. 기타휴가는 상세사유를 자세하게 필히 작성해주세요.",
                    icon: 'warning',
                    showCancelButton: false,
                    backdrop:false
                }).then(() => {
                    insert.set("vac_tel",vacationTelInfo);
                    insert.set("vac_reason",vacReason);
                    insert.set("vac_start", vacationDateInfo.start);
                    insert.set("vac_end", vacationDateInfo.end);
                    insert.set("vac_days", vacUseDay);
                    insert.set("vac_category", vacationCategory.value);
                    addBody(Object.fromEntries(insert));
                })
            } else {
                insert.set("vac_tel",vacationTelInfo);
                insert.set("vac_reason",vacReason);
                insert.set("vac_start", vacationDateInfo.start);
                insert.set("vac_end", vacationDateInfo.end);
                insert.set("vac_days", vacUseDay);
                insert.set("vac_category", vacationCategory.value);
                addBody(Object.fromEntries(insert));
            }
        }
    }

    // 저장
    function save() {
        let flag = true;
        const insert = toMap(vacationInfo);
        insert.set("auth_no", user?.role);
        insert.set("mem_no", user?.id);
        insert.set("mem_name", user?.name);
        insert.set("vac_team", user?.team);
        insert.set("vac_rank", user?.rank);
        const approverList = cloneDeep(approverInfo).approverList;
        insert.set("approverList", cloneDeep(approverInfo).approverList)
        insert.set("referrerList", cloneDeep(referrerInfo).referrerList)

        if(vacationDateInfo.start === "" || vacationDateInfo.end === ""){
            flag=false;
            vacationErrorHandle("휴가 일정을 올바르게 선택하여 주십시오.");
        } else if(vacationDayError !== true){
            flag=false;
            vacationErrorHandle("사용예정 일수와 잔여 연차가 맞지 않습니다. 확인하여 주십시오.");
        } else if (vacationCategory.value === "" || vacationCategory.value === undefined) {
            flag=false;
            vacationErrorHandle("휴가 구분을 올바르게 선택하여 주십시오.");
        } else if (PhoneNumCheck(vacationTelInfo) === false) {
            flag=false;
            vacationErrorHandle("연락처를 올바르게 입력하여 주십시오.");
        } else if(vacUseDay === "" || vacUseDay === "0"){
            flag=false;
            vacationErrorHandle("사용예정 휴가일을 확인해주세요.");
        } else if (vacReason === "") {
            flag=false;
            vacationErrorHandle("휴가 사유를 입력하여 주십시오.");
        } else if (approverList !== null){
            if (approverList.length > 0 ) {
                insert.set("vac_approved", "AP001");
            } else {
                flag=false;
                vacationErrorHandle("결재자를 선택하여 주십시오.");
            }
        } else {
            flag=false;
            vacationErrorHandle("결재자를 선택하여 주십시오.");
        }

        if(flag) {
            if(vacationCategory.value === "VT003") {
                Swal.fire({
                    title: "1. 예비군 교육훈련 필증, 민방위 훈련 참가 필증을 경영지원부에 꼭 제출해주세요.\n2. 기타휴가는 상세사유를 자세하게 필히 작성해주세요.",
                    icon: 'warning',
                    showCancelButton: false,
                    backdrop:false
                }).then(() => {
                    insert.set("vac_tel",vacationTelInfo);
                    insert.set("vac_reason",vacReason);
                    insert.set("vac_start", vacationDateInfo.start);
                    insert.set("vac_end", vacationDateInfo.end);
                    insert.set("vac_days", vacUseDay);
                    insert.set("vac_category", vacationCategory.value);
                    addBody(Object.fromEntries(insert));
                })
            } else {
                insert.set("vac_tel",vacationTelInfo);
                insert.set("vac_reason",vacReason);
                insert.set("vac_start", vacationDateInfo.start);
                insert.set("vac_end", vacationDateInfo.end);
                insert.set("vac_days", vacUseDay);
                insert.set("vac_category", vacationCategory.value);
                addBody(Object.fromEntries(insert));
            }
        }
    }

    // 휴가 입력
    const { mutate: addBody, isLoading} = useMutation(InsertVacation, {
        onSuccess: (data) => {
            // 리셋
            atomReset();
            navigate("/vacation/view",{state:parseInt(data.data)});
        },
        onError: () => {
            handleInsertError();
        },
    });

    if(isLoading) {
        return (
            <Loading/>
        )
    }

    /**
     * 휴가입력 에러 핸들
     */
    const handleInsertError = () => {
        Swal.fire({
            title: '휴가입력 중 에러가 발생했습니다. ',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '휴가메인페이지',
            backdrop:false

        }).then((result) => {
            if (result.isConfirmed) {
                // 리셋
                atomReset();
            } else {
                // 리셋
                atomReset();
                navigate('/vacation');
            }
        })
    }

    /**
     * 휴가 error 핸들
     * @param value : String error내용
     */
    const vacationErrorHandle = (value) => {
        Swal.fire({
            title: `${value}`,
            icon: 'warning',
            showCancelButton: false,
            backdrop:false
        })
    }

    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <SoftBox py={3}>
                {/* 휴가 입력 영역*/}
                <VacationInputArea keyName={insertKey}/>
                {/* 결재 참조 라인*/}
                <ApproverReferrer approverKey={approverKey} referrerKey={referrerKey}/>
                <Grid container spacing={3} mt={0.5} mb={0.5}>
                    <Grid item xs={12} md={12} lg={12} display="flex" justifyContent="center" alignItems="center">
                        <SoftBox>
                            <SoftButton variant="gradient" color="info" onClick={temporary}>
                                <Icon sx={{fontWeight: "bold"}}>person_add</Icon>
                                &nbsp;임시저장
                            </SoftButton>
                        </SoftBox>
                        &nbsp;&nbsp;&nbsp;
                        <SoftBox>
                            <SoftButton variant="gradient" color="success" onClick={save}>
                                <Icon sx={{fontWeight: "bold"}}>person_add</Icon>
                                &nbsp;문서상신
                            </SoftButton>
                        </SoftBox>
                    </Grid>
                </Grid>
            </SoftBox>
            <Footer/>
        </DashboardLayout>
    );
}

export default VacationInsert;
